import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import classnames from 'classnames';

const GroupWithPrevButton = (props) => {
  const cx = classnames({
    glyphicon: true,
    'glyphicon-hand-down': props.grouped,
    'glyphicon-hand-up': !props.grouped,
  });

  return (
    <Button
      className="group-with-prev-btn"
      title={props.grouped ? 'Ungroup from previous' : 'Group with previous'}
      onClick={props.onClick}
    >
      <span>
        <i className={cx} />
      </span>
    </Button>
  );
};

GroupWithPrevButton.propTypes = {
  grouped: PropTypes.bool,
  onClick: PropTypes.func,
};

GroupWithPrevButton.defaultProps = {
  grouped: false,
};

export default GroupWithPrevButton;
